export default __webpack_public_path__ + "static/media/109.d3db8cc5.jpg";